import {lazy} from 'react';

const Gongchuang = lazy(() => import('@/modules/gongchuang'));
const Welcomeh5 = lazy(() => import('@/modules/welcomeh5'));
const Recommendation = lazy(() => import('@/modules/recommendation'));
const AiTemplate = lazy(() => import('@/modules/aiTemplate'));
const ActAI = lazy(() => import('@/modules/actAI'));
const NewYear2025 = lazy(() => import('@/modules/activity/newYear2025'));
const AiBless = lazy(() => import('@/modules/aiCreate/pages/bless'));
const AiHighLight = lazy(() => import('@/modules/aiCreate/pages/highLight'));
const AiPK = lazy(() => import('@/modules/aiCreate/pages/pk'));
const PkViewPoint = lazy(() => import('@/modules/aiCreate/pages/pkViewPoint'));
const AiPoem = lazy(() => import('@/modules/aiCreate/pages/poem'));
const actAIList = lazy(() => import('@/modules/actAI/list'));
const ActAICreate = lazy(() => import('@/modules/actAI/create'));
const AiCouplet = lazy(() => import('@/modules/aiCreate/pages/couplet'));
const WealthGod = lazy(() => import('@/modules/aiCreate/pages/wealthGold'));
const LootFu = lazy(() => import('@/modules/aiCreate/pages/lootFu'));
const Lantern = lazy(() => import('@/modules/aiCreate/pages/lantern'));
// 敏捷问卷卡片
const Research = lazy(() => import('@/modules/research'));

const routes = [
    {
        path: '/campaign/gongchuang',
        Component: Gongchuang,
    },
    {
        path: '/campaign/welcomeh5',
        Component: Welcomeh5,
    },
    {
        path: '/campaign/actAI',
        Component: ActAI,
    },
    {
        path: '/campaign/actAICreate',
        Component: ActAICreate,
    },
    {
        path: '/h5/inspiration/rec',
        Component: Recommendation,
    },
    {
        path: '/h5/inspiration/aiTpl',
        Component: AiTemplate,
    },
    {
        path: '/h5/activity/new-year-2025',
        Component: NewYear2025,
    },
    {
        path: '/h5/bless',
        Component: AiBless,
    },
    {
        path: '/h5/ai-create/highlight',
        Component: AiHighLight,
    },
    {
        path: '/h5/ai-create/pk',
        Component: AiPK,
    },
    {
        path: '/h5/ai-create/pk-viewpoint',
        Component: PkViewPoint,
    },
    {
        path: '/h5/ai-create/poem',
        Component: AiPoem,
    },
    {
        path: '/campaign/actAI/list',
        Component: actAIList,
    },
    {
        path: '/h5/ai-create/couplet',
        Component: AiCouplet,
    },
    {
        path: '/h5/ai-create/wealthgod',
        Component: WealthGod,
    },
    {
        path: '/h5/ai-create/lantern',
        Component: Lantern,
    },
    {
        path: '/h5/ai-create/lootFu',
        Component: LootFu,
    },
    {
        path: '/h5/research',
        Component: Research,
    },
];

export default routes;
